import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StepFormData {
  [key: string]: any;
}

interface SchoolFeeState {
  applicationId: string | null;
  formData: {
    step1: StepFormData;
    step2: StepFormData;
    step3: StepFormData;
  };
}

interface SaveFormDataPayload {
  applicationId: string;
  formData: StepFormData;
  step: 'step1' | 'step2' | 'step3';
}

const initialState: SchoolFeeState = {
  applicationId: null,
  formData: {
    step1: {},
    step2: {},
    step3: {},
  },
};

export const myselfFee = createSlice({
  name: 'schoolfee',
  initialState,
  reducers: {
    saveMySchoolFee: (state, action: PayloadAction<SaveFormDataPayload>) => {
      const { applicationId, formData, step } = action.payload;
      state.applicationId = applicationId;
      state.formData[step] = formData;
    },
    clearMySchoolForm: (state) => {
      state.applicationId = null;
      state.formData = { step1: {}, step2: {}, step3: {} };
    },
  },
});

export const { saveMySchoolFee, clearMySchoolForm } = myselfFee.actions;
export default myselfFee.reducer;
